/// <amd-module name="Dashboards/CommonConfig/InlineError" />
import * as React from "react";
import { css, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";

export interface InlineErrorProps extends IVssComponentProperties {
    message?: string;
}

export class InlineError extends VssComponent<InlineErrorProps> {
    public render(): JSX.Element {
        const contentDescription = this.props.message == null || this.props.message === "" ? "empty" : "";
        return (
            <div className={css("inline-configuration-error", contentDescription)}>
                {this.props.message != null && (
                    <>
                        <VssIcon iconName="Error" iconType={VssIconType.fabric} />
                        <span role="alert">{this.props.message}</span>
                    </>
                )}
            </div>
        );
    }
}
